import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, Validator } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { RespuestaGenerica } from '../../models/generic/RespuestaGenerica';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { Maestro_Aliados } from '../../models/generic/Maestro_Aliados';
import { Maestro_EstadoActualizar } from 'src/app/models/generic/Maestro_EstadoActualizar';
import { Maestro_Aliados_Actualizacion } from '../../models/generic/Maestro_Aliados_Actualizacion';
import { Maestro_Provincias } from 'src/app/models/generic/Maestro_Provincias';
import { Maestro_Ciudades } from 'src/app/models/generic/Maestro_Ciudades';
import { Maestros_ProvinciasService } from 'src/app/services/maestros_provincias';
import { Maestros_CiudadesService } from 'src/app/services/maestros_ciudades';
import { MaestroSectores } from 'src/app/models/generic/Maestro_Sectores';
import { Maestros_SectorService } from 'src/app/services/maestros_sector.service';
import { Maestro_AliadosCanales } from 'src/app/models/generic/Maestro_AliadosCanales';
import { Maestros_AliadosService } from '../../services/maestros_aliados.service';
import { Maestros_AliadosCanalesService } from '../../services/maestros_aliadoscanales.service';
import { Maestro_Notificaciones } from '../../models/generic/Maestro_Notificaciones';
import { Maestros_AliadosNotificacionesService } from '../../services/maestros_aliadosnotificaciones.service';
import { Listas } from '../../models/generic/Listas';
import { ModificarPlantillaComponent } from '../modificar-plantilla/modificar-plantilla.component';
import { Maestro_AliadosPorcentajeBeneficiarios } from 'src/app/models/generic/Maestro_AliadosPorcentajeBeneficiarios';
import { Maestros_AliadosPorcentajesBeneficiariosService } from '../../services/maestros_aliadosporcentajesbeneficiarios.service';
import { Maestro_Parametros } from 'src/app/models/generic/Maestro_Parametros';
import { Maestros_ParametrosService } from 'src/app/services/maestros_parametros.service';

@Component({
  selector: 'maestros-aliados-editar',
  templateUrl: './maestros-aliados-editar.component.html',
  styleUrls: ['./maestros-aliados-editar.component.scss']
})
export class MaestrosAliadosEditarComponent implements OnInit{
  
  form: FormGroup;
  formConsulta: FormGroup;
  tituloForma: string = 'Registro de aliados';
  tituloBoton: string = 'Registrar aliados';
  mostrarCargando: boolean = false;
  codigoAccion: string = '';
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  @ViewChild('modificarplantillahtml', {static: false}) _modificarplantillahtml: ModificarPlantillaComponent;
  listaEstado: Maestro_EstadoActualizar[] = [];
  listaCondicionSiNo: Maestro_EstadoActualizar[] = [];
  listaFiltroArchivos: Listas[] = [];
  listaTipoProceso: Listas[] = [];
  idTabSeleccionado: number = 0;

  detalleSeleccionado: number;
  detalleSeleccionadoNotificacion: number;
  detalleSeleccionadoPorcentajeBeneficiarios: number;
  detalleSeleccionadoParametros: number;
  formCanales: FormGroup;
  formNotificaciones: FormGroup;
  formPorcentajesBeneficiarios: FormGroup;
  formParametros: FormGroup;
  editarRegistroCanal: boolean = false;
  editarRegistroNotificacion: boolean = false;
  editarRegistroPorcentajeBeneficiarios: boolean = false;
  editarRegistroParametros: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSourceCanales: MatTableDataSource<Maestro_AliadosCanales>;
  dataSourceNotificaciones: MatTableDataSource<Maestro_Notificaciones>;
  dataSourcePorcentajesBenerifiarios: MatTableDataSource<Maestro_AliadosPorcentajeBeneficiarios>;
  dataSourceParametros: MatTableDataSource<Maestro_Parametros>;
  columnasEncabezadoCanales: string[] = ['id', 'nombre', 'activo', 'acciones'];
  columnasEncabezadoNotificaciones: string[] = ['id', 'descripcionTipoProceso', 'enviarSMS', 'enviarEmail', 'activo', 'acciones'];
  columnasEncabezadoPorcentajesBeneficiarios: string[] = ['id', 'porcentaje', 'descripcion', 'orden', 'acciones'];
  columnasEncabezadoParametros: string[] = ['parametro', 'valorParametro', 'acciones'];
  listaDatosCanales: Maestro_AliadosCanales[] = [];
  listaDatosCanalesEliminar: Maestro_AliadosCanales[] = [];
  listaDatosNotificaciones: Maestro_Notificaciones[] = [];
  listaDatosNotificacionesEliminar: Maestro_Notificaciones[] = [];
  listaDatosPorcentajesBeneficiarios: Maestro_AliadosPorcentajeBeneficiarios[] = [];
  listaDatosPorcentajesBeneficiariosEliminar: Maestro_AliadosPorcentajeBeneficiarios[] = [];
  listaDatosParametros: Maestro_Parametros[] = [];
  parametrosPrincipal: Maestro_Aliados;
  listaSector: MaestroSectores[] = [];
  listaProvincias: Maestro_Provincias[] = [];
  listaCiudades: Maestro_Ciudades[] = [];
  listaCiudadesEdicion: Maestro_Ciudades[] = [];
  listaCiudadesEdicionCanal: Maestro_Ciudades[] = [];
  mostrarEdicionNotificaciones: boolean = false;
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: Maestros_AliadosService,
    public datosCanalesServices: Maestros_AliadosCanalesService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public sectorService: Maestros_SectorService,
    public provinciasService: Maestros_ProvinciasService,
    public ciudadesServices: Maestros_CiudadesService,
    public datosNotificacionesServices: Maestros_AliadosNotificacionesService,
    public datosPorcentajesBeneficiariosServices: Maestros_AliadosPorcentajesBeneficiariosService,
    public datosParametrosServices: Maestros_ParametrosService) {}

  ngOnInit() {
    this.IniciarFormulario();
    this.ConsultarSectores();
    this.listaEstado = [];
    this.listaCondicionSiNo = [];
    this.listaTipoProceso = [];
    this.listaFiltroArchivos = [];

    this.listaEstado.push({ seleccionado: true, descripcion: 'Activo' });
    this.listaEstado.push({ seleccionado: false, descripcion: 'Inactivo' });

    this.listaCondicionSiNo.push({ seleccionado: true, descripcion: 'Si' });
    this.listaCondicionSiNo.push({ seleccionado: false, descripcion: 'No' });

    this.listaTipoProceso.push(this.CrearItemProceso('R', 'Registrar'));
    this.listaTipoProceso.push(this.CrearItemProceso('E', 'Cambiar estado'));
    this.listaTipoProceso.push(this.CrearItemProceso('A', 'Activación asistencia'));
    this.listaTipoProceso.push(this.CrearItemProceso('C', 'Registro carga masiva'));
    this.listaTipoProceso.push(this.CrearItemProceso('U', 'Firma electrónica código autorización'));
    this.listaTipoProceso.push(this.CrearItemProceso('F', 'Firma electrónica documento'));

    this.listaFiltroArchivos.push(this.CrearItemProceso('excel', 'EXCEL'));
    this.listaFiltroArchivos.push(this.CrearItemProceso('txt', 'TXT'));
    this.listaFiltroArchivos.push(this.CrearItemProceso('csv', 'CSV'));

    this.listaDatosCanalesEliminar = [];
    this.listaDatosNotificacionesEliminar = [];
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginator);
    
    if (this.utilitariosService.VerificarContieneDatos(this.menuService.ParametrosAdicionales)) {
      this.parametrosPrincipal = JSON.parse(this.menuService.ParametrosAdicionales);

      // console.log('setea valor', this.parametrosPrincipal);
      this.form.setValue(this.parametrosPrincipal);
      
      this.tituloForma = 'Edición de aliados';
      this.tituloBoton = 'Editar aliado';
    }
    
    this.ConsultarRegistrosCanales();
    this.ConsultarRegistrosNotificaciones();
    this.ConsultarRegistrosPorcentajesBeneficiarios();
    this.ConsultarRegistrosParametros();
  }
  CrearItemProceso(tipoProceso: string, descripcion: string): Listas {
    let itemRetorno: Listas = new Listas();
    itemRetorno.codigo = tipoProceso;
    itemRetorno.descripcion = descripcion;
    return itemRetorno;
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      id: [0],
      idAplicacion: [0],
      nombre: ['', [Validators.required, Validators.maxLength(100)]],
      idSector: [0],
      sector: [''],
      nroIdentificacion: [''],
      domicilio: [''],
      provincia: [''],
      provinciaDescripcion: [''],
      ciudad: [''],
      ciudadDescripcion: [''],
      activo: [true],
      manejaCartera: [false],
      registrar: [false],
      calculoPrecioEdad: [false],
      notificarCambios: [false],
      recaudoWeb: [false],
      filtrarProductoCanal: [false],
      cargarProspectos: [false],
      filtroFormatoProspecto: [''],
      nombreFormatoProspecto: [''],
      manejaProgramas: [false],
      expedientes: [false],
      cambioEstadoAfiliacion: [false],
      migracionClientesAliados: [false],
      nombreClientesAliados: [''],
      nombreBaseDatos: ['', [Validators.required, Validators.maxLength(100)]],
    });

    this.form.get('provincia').valueChanges.subscribe((valorNuevo) => {
      this.CiudadesProvincia(valorNuevo);
    });

    this.formConsulta = this.fb.group({
      id: [0],
      filtro: ['']
    });

    this.IniciarFormularioCanales();
    this.IniciarFormularioNotificaciones();
    this.IniciarFormularioPorcentajesBeneficiarios();
    this.IniciarFormularioParametros();
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo('MaestrosAliadosComponent');
  }
  Guardar() {
    if (this.form.valid) {
      this.codigoAccion = 'guardar';
      this._appconfirmacion.MostrarMensajeConfirmacion();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.form);
    }
  }
  ConfirmoUsuario(confirmo: boolean) {
    if (confirmo) {
      if (this.codigoAccion === 'guardar') {
        this.ActualizarRegistro();
      } else {
        if (this.codigoAccion === 'eliminarCanal') {
          this.EliminarRegistroCanal();
        } else if (this.codigoAccion === 'eliminarNotificacion') {
          this.EliminarRegistroNotificacion();
        } else if (this.codigoAccion === 'eliminarPorcentajesBeneficiarios') {
          this.EliminarRegistroPorcentajesBeneficiarios();
        }
      }
    }
  }
  ActualizarRegistro() {
    this.mostrarCargando = true;
    
    let parametrosActualizacion: Maestro_Aliados_Actualizacion = new Maestro_Aliados_Actualizacion();
    parametrosActualizacion.principal = new Maestro_Aliados();
    parametrosActualizacion.principal.id = this.form.get('id').value;
    parametrosActualizacion.principal.idAplicacion = this.form.get('idAplicacion').value;
    parametrosActualizacion.principal.nombre = this.form.get('nombre').value;
    parametrosActualizacion.principal.idSector = this.form.get('idSector').value;
    parametrosActualizacion.principal.sector = this.form.get('sector').value;
    parametrosActualizacion.principal.nroIdentificacion = this.form.get('nroIdentificacion').value;
    parametrosActualizacion.principal.domicilio = this.form.get('domicilio').value;
    parametrosActualizacion.principal.provincia = this.form.get('provincia').value;
    parametrosActualizacion.principal.provinciaDescripcion = this.form.get('provinciaDescripcion').value;
    parametrosActualizacion.principal.ciudad = this.form.get('ciudad').value;
    parametrosActualizacion.principal.ciudadDescripcion = this.form.get('ciudadDescripcion').value;
    parametrosActualizacion.principal.activo = this.form.get('activo').value;
    parametrosActualizacion.principal.manejaCartera = this.form.get('manejaCartera').value;
    parametrosActualizacion.principal.registrar = this.form.get('registrar').value;
    parametrosActualizacion.principal.calculoPrecioEdad = this.form.get('calculoPrecioEdad').value;
    parametrosActualizacion.principal.notificarCambios = this.form.get('notificarCambios').value;
    parametrosActualizacion.principal.recaudoWeb = this.form.get('recaudoWeb').value;
    parametrosActualizacion.principal.filtrarProductoCanal = this.form.get('filtrarProductoCanal').value;
    parametrosActualizacion.principal.cargarProspectos = this.form.get('cargarProspectos').value;
    parametrosActualizacion.principal.filtroFormatoProspecto = this.form.get('filtroFormatoProspecto').value;
    parametrosActualizacion.principal.nombreFormatoProspecto = this.form.get('nombreFormatoProspecto').value;
    parametrosActualizacion.principal.manejaProgramas = this.form.get('manejaProgramas').value;
    parametrosActualizacion.principal.expedientes = this.form.get('expedientes').value;
    parametrosActualizacion.principal.cambioEstadoAfiliacion = this.form.get('cambioEstadoAfiliacion').value;
    parametrosActualizacion.principal.migracionClientesAliados = this.form.get('migracionClientesAliados').value;
    parametrosActualizacion.principal.nombreClientesAliados = this.form.get('nombreClientesAliados').value;
    parametrosActualizacion.principal.nombreBaseDatos = this.form.get('nombreBaseDatos').value;
    
    parametrosActualizacion.listaCanales = this.listaDatosCanales;
    parametrosActualizacion.listaCanalesEliminar = this.listaDatosCanalesEliminar;
    parametrosActualizacion.listaNotificaciones = this.listaDatosNotificaciones;
    parametrosActualizacion.listaNotificacionesEliminar = this.listaDatosNotificacionesEliminar;
    parametrosActualizacion.listaPorcentajesBeneficiarios = this.listaDatosPorcentajesBeneficiarios;
    parametrosActualizacion.listaPorcentajesBeneficiariosEliminar = this.listaDatosPorcentajesBeneficiariosEliminar;
    parametrosActualizacion.listaParametros = this.listaDatosParametros;

    this.datosServices.Actualizar(parametrosActualizacion)
            .subscribe((resp: RespuestaGenerica) =>{
              console.log('ActualizarRegistro', resp, resp.procesoExitoso);
              if (resp.procesoExitoso == false) {
                this.utilitariosService.MensajeToast(resp.mensaje);
              } else {
                this.menuService.CambiarComponenteActivo('MaestrosAliadosComponent');
              }
              this.mostrarCargando = false;
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  ConsultarRegistrosCanales() {
    this.mostrarCargando = true;
    this.formConsulta.get('id').setValue(this.parametrosPrincipal.id);
    this.datosCanalesServices.Consultar(this.formConsulta.value)
              .subscribe((resp: Maestro_AliadosCanales[]) =>{
                this.mostrarCargando = false;
                this.listaDatosCanales = resp;
                this.recargarListaCanales();
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  ConsultarRegistrosNotificaciones() {
    this.mostrarCargando = true;
    this.formConsulta.get('id').setValue(this.parametrosPrincipal.id);
    this.datosNotificacionesServices.Consultar(this.formConsulta.value)
              .subscribe((resp: Maestro_Notificaciones[]) =>{
                this.mostrarCargando = false;
                for (let index = 0; index < resp.length; index++) {
                  if (this.utilitariosService.VerificarContieneDatosTexto(resp[index].emailMensaje)) {
                    resp[index].emailMensajeMostrar = 'Mensaje html...';
                  } else {
                    resp[index].emailMensajeMostrar = '';
                  }
                }
                this.listaDatosNotificaciones = resp;
                this.recargarListaNotificaciones();
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  ConsultarRegistrosPorcentajesBeneficiarios() {
    this.mostrarCargando = true;
    this.formConsulta.get('id').setValue(this.parametrosPrincipal.id);
    this.datosPorcentajesBeneficiariosServices.Consultar(this.formConsulta.value)
              .subscribe((resp: Maestro_AliadosPorcentajeBeneficiarios[]) =>{
                this.mostrarCargando = false;
                this.listaDatosPorcentajesBeneficiarios = resp;
                this.recargarListaPorcentajesBeneficiarios();
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  ConsultarRegistrosParametros() {
    this.mostrarCargando = true;
    this.formConsulta.get('id').setValue(this.parametrosPrincipal.id);
    this.datosParametrosServices.Consultar(this.formConsulta.value)
              .subscribe((resp: Maestro_Parametros[]) =>{
                this.mostrarCargando = false;
                this.listaDatosParametros = resp;
                this.recargarListaParametros();
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  tabSeleccionado(item: any) {
    this.idTabSeleccionado = item.index;    
  }

  IniciarFormularioCanales() {
    this.formCanales = this.fb.group({
      id: [0],
      idAliado: [0],
      nombreAliado: [''],
      nombre: ['', [Validators.required, Validators.maxLength(100)]],
      domicilio: [''],
      provincia: [''],
      provinciaDescripcion: [''],
      ciudad: [''],
      ciudadDescripcion: [''],
      activo: [true]
    });

    this.formCanales.get('provincia').valueChanges.subscribe((valorNuevo) => {
      this.CiudadesProvinciaCanales(valorNuevo);
    });
  }
  IniciarFormularioNotificaciones() {
    this.formNotificaciones = this.fb.group({
      id: [0],
      idAliado: [0],
      nombreAliado: [''],
      tipoProceso: ['', [Validators.required]],
      descripcionTipoProceso: [''],
      enviarSMS: [true],
      smsTexto: [''],
      enviarEmail: [true],
      emailFrom: [''],
      emailReplyTo: [''],
      emailSubject: [''],
      emailMensaje: [''],
      emailMensajeMostrar: [''],
      activo: [true]
    });

    this.EstablecerValidacionesNotificaciones();

    this.formNotificaciones.get('enviarSMS').valueChanges.subscribe((valorNuevo) => {
      let validatorsSMS = [];

      if (valorNuevo) {
        validatorsSMS.push(Validators.required);
        validatorsSMS.push(Validators.maxLength(260));
      }
      
      this.formNotificaciones.get('smsTexto').setValidators(validatorsSMS);
      this.formNotificaciones.get('smsTexto').updateValueAndValidity();
      
    });

    this.formNotificaciones.get('enviarEmail').valueChanges.subscribe((valorNuevo) => {
      let validatorsSoloRequerido = [];
      let validatorsEmail = [];

      if (valorNuevo) {
        validatorsEmail.push(Validators.required);
        validatorsEmail.push(Validators.maxLength(100));

        validatorsSoloRequerido.push(Validators.required);
      }
      
      this.formNotificaciones.get('emailFrom').setValidators(validatorsEmail);
      this.formNotificaciones.get('emailFrom').updateValueAndValidity();
      this.formNotificaciones.get('emailReplyTo').setValidators(validatorsEmail);
      this.formNotificaciones.get('emailReplyTo').updateValueAndValidity();
      this.formNotificaciones.get('emailSubject').setValidators(validatorsEmail);
      this.formNotificaciones.get('emailSubject').updateValueAndValidity();
      this.formNotificaciones.get('emailMensajeMostrar').setValidators(validatorsSoloRequerido);
      this.formNotificaciones.get('emailMensajeMostrar').updateValueAndValidity();
    });
  }
  EstablecerValidacionesNotificaciones() {
    let validatorsSMS = [];
    let validatorsSoloRequerido = [];
    let validatorsEmail = [];

    if (this.formNotificaciones.get('enviarSMS').value) {
      validatorsSMS.push(Validators.required);
      validatorsSMS.push(Validators.maxLength(260));
    }
    
    this.formNotificaciones.get('smsTexto').setValidators(validatorsSMS);
    this.formNotificaciones.get('smsTexto').updateValueAndValidity();

    if (this.formNotificaciones.get('enviarEmail').value) {
      validatorsEmail.push(Validators.required);
      validatorsEmail.push(Validators.maxLength(100));

      validatorsSoloRequerido.push(Validators.required);
    }
    
    this.formNotificaciones.get('emailFrom').setValidators(validatorsEmail);
    this.formNotificaciones.get('emailFrom').updateValueAndValidity();
    this.formNotificaciones.get('emailReplyTo').setValidators(validatorsEmail);
    this.formNotificaciones.get('emailReplyTo').updateValueAndValidity();
    this.formNotificaciones.get('emailSubject').setValidators(validatorsEmail);
    this.formNotificaciones.get('emailSubject').updateValueAndValidity();
    this.formNotificaciones.get('emailMensajeMostrar').setValidators(validatorsSoloRequerido);
    this.formNotificaciones.get('emailMensajeMostrar').updateValueAndValidity();
  }
  IniciarFormularioPorcentajesBeneficiarios() {
    this.formPorcentajesBeneficiarios = this.fb.group({
      id: [0],
      idAliado: [0],
      nombreAliado: [''],
      porcentaje: [0, [Validators.required, Validators.min(1), Validators.max(100)]],
      descripcion: ['', [Validators.required, Validators.maxLength(20)]],
      orden: [0]
    });
  }
  IniciarFormularioParametros() {
    this.formParametros = this.fb.group({
      parametro: [''],
      valorParametro: [''],
    });
  }
  recargarListaCanales() {
    this.dataSourceCanales = new MatTableDataSource(this.listaDatosCanales);
    this.dataSourceCanales.paginator = this.paginator;
    this.dataSourceCanales.sort = this.sort;
  }
  recargarListaNotificaciones() {
    this.dataSourceNotificaciones = new MatTableDataSource(this.listaDatosNotificaciones);
    this.dataSourceNotificaciones.paginator = this.paginator;
    this.dataSourceNotificaciones.sort = this.sort;
  }
  recargarListaPorcentajesBeneficiarios() {
    this.dataSourcePorcentajesBenerifiarios = new MatTableDataSource(this.listaDatosPorcentajesBeneficiarios);
    this.dataSourcePorcentajesBenerifiarios.paginator = this.paginator;
    this.dataSourcePorcentajesBenerifiarios.sort = this.sort;
  }
  recargarListaParametros() {
    this.dataSourceParametros = new MatTableDataSource(this.listaDatosParametros);
    this.dataSourceParametros.paginator = this.paginator;
    this.dataSourceParametros.sort = this.sort;
  }
  NuevoCanal() {
    this.editarRegistroCanal = true;
    this.IniciarFormularioCanales();
    this.formCanales.get('id').setValue((this.listaDatosCanales.length + 1) * -1);
  }
  NuevoNotificacion() {
    this.editarRegistroNotificacion = true;
    this.IniciarFormularioNotificaciones();
    this.formNotificaciones.get('id').setValue((this.listaDatosNotificaciones.length + 1) * -1);
  }
  NuevoPorcentajesBeneficiarios() {
    this.editarRegistroPorcentajeBeneficiarios = true;
    this.IniciarFormularioPorcentajesBeneficiarios();
    this.formPorcentajesBeneficiarios.get('id').setValue((this.listaDatosPorcentajesBeneficiarios.length + 1) * -1);
  }
  EditarCanal(canalEditar: Maestro_AliadosCanales) {
    this.editarRegistroCanal = true;
    this.formCanales.setValue(canalEditar);
  }
  EditarNotificacion(notificacionEditar: Maestro_Notificaciones) {
    this.editarRegistroNotificacion = true;
    this.formNotificaciones.setValue(notificacionEditar);
  }
  EditarPorcentajeBeneficiarios(notificacionEditar: Maestro_AliadosPorcentajeBeneficiarios) {
    this.editarRegistroPorcentajeBeneficiarios = true;
    this.formPorcentajesBeneficiarios.setValue(notificacionEditar);
  }
  EditarParametros(notificacionEditar: Maestro_Parametros) {
    this.editarRegistroParametros = true;
    this.formParametros.setValue(notificacionEditar);
  }
  EditarPorcentajesN(notificacionEditar: Maestro_Notificaciones) {
    this.editarRegistroNotificacion = true;
    this.formNotificaciones.setValue(notificacionEditar);
  }
  EliminarCanal(canalEditar: Maestro_AliadosCanales) {
    this.detalleSeleccionado = canalEditar.id;
    this.codigoAccion = 'eliminarCanal';
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  EliminarNotificacion(notificacionEditar: Maestro_Notificaciones) {
    this.detalleSeleccionadoNotificacion = notificacionEditar.id;
    this.codigoAccion = 'eliminarNotificacion';
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  EliminarPorcentajeBeneficiarios(notificacionEditar: Maestro_AliadosPorcentajeBeneficiarios) {
    this.detalleSeleccionadoPorcentajeBeneficiarios = notificacionEditar.id;
    this.codigoAccion = 'eliminarPorcentajesBeneficiarios';
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  GuardarCanal() {
    if (this.formCanales.valid) {
      this.editarRegistroCanal = false;
      if (this.listaDatosCanales.filter(x => x.id === this.formCanales.get('id').value).length > 0) {
        let parametroActualizar = this.listaDatosCanales.filter(x => x.id === this.formCanales.get('id').value)[0];
        parametroActualizar.nombreAliado = this.formCanales.get('nombreAliado').value;
        parametroActualizar.nombre = this.formCanales.get('nombre').value;
        parametroActualizar.domicilio = this.formCanales.get('domicilio').value;
        parametroActualizar.provincia = this.formCanales.get('provincia').value;
        parametroActualizar.provinciaDescripcion = this.formCanales.get('provinciaDescripcion').value;
        parametroActualizar.ciudad = this.formCanales.get('ciudad').value;
        parametroActualizar.ciudadDescripcion = this.formCanales.get('ciudadDescripcion').value;
        parametroActualizar.activo = this.formCanales.get('activo').value;
      } else {
        this.listaDatosCanales.push(this.formCanales.value);
      }
      
      this.recargarListaCanales();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.formCanales);
    }
  }
  GuardarNotificacion() {
    if (this.formNotificaciones.valid) {
      if (this.formNotificaciones.get('tipoProceso').value === 'R') {
        this.formNotificaciones.get('descripcionTipoProceso').setValue('Registrar');
      } else if (this.formNotificaciones.get('tipoProceso').value === 'E') {
        this.formNotificaciones.get('descripcionTipoProceso').setValue('Cambiar estado');
      } else if (this.formNotificaciones.get('tipoProceso').value === 'A') {
        this.formNotificaciones.get('descripcionTipoProceso').setValue('Activación asistencia');
      } else if (this.formNotificaciones.get('tipoProceso').value === 'C') {
        this.formNotificaciones.get('descripcionTipoProceso').setValue('Registro carga masiva');
      } else if (this.formNotificaciones.get('tipoProceso').value === 'U') {
        this.formNotificaciones.get('descripcionTipoProceso').setValue('Firma electrónica código autorización');
      } else if (this.formNotificaciones.get('tipoProceso').value === 'F') {
        this.formNotificaciones.get('descripcionTipoProceso').setValue('Firma electrónica documento');
      }

      this.editarRegistroNotificacion = false;
      if (this.listaDatosNotificaciones.filter(x => x.id === this.formNotificaciones.get('id').value).length > 0) {
        let parametroActualizar = this.listaDatosNotificaciones.filter(x => x.id === this.formNotificaciones.get('id').value)[0];
        parametroActualizar.nombreAliado = this.formNotificaciones.get('nombreAliado').value;
        parametroActualizar.tipoProceso = this.formNotificaciones.get('tipoProceso').value;
        parametroActualizar.descripcionTipoProceso = this.formNotificaciones.get('descripcionTipoProceso').value;
        parametroActualizar.enviarSMS = this.formNotificaciones.get('enviarSMS').value;
        parametroActualizar.smsTexto = this.formNotificaciones.get('smsTexto').value;
        parametroActualizar.enviarEmail = this.formNotificaciones.get('enviarEmail').value;
        parametroActualizar.emailFrom = this.formNotificaciones.get('emailFrom').value;
        parametroActualizar.emailReplyTo = this.formNotificaciones.get('emailReplyTo').value;
        parametroActualizar.emailSubject = this.formNotificaciones.get('emailSubject').value;
        parametroActualizar.emailMensaje = this.formNotificaciones.get('emailMensaje').value;
        parametroActualizar.activo = this.formNotificaciones.get('activo').value;
      } else {
        this.listaDatosNotificaciones.push(this.formNotificaciones.value);
      }
      
      this.recargarListaNotificaciones();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.formNotificaciones);
    }
  }
  GuardarPorcentajeBeneficiarios() {
    if (this.formPorcentajesBeneficiarios.valid) {
      this.editarRegistroPorcentajeBeneficiarios = false;
      if (this.listaDatosPorcentajesBeneficiarios.filter(x => x.id === this.formPorcentajesBeneficiarios.get('id').value).length > 0) {
        let parametroActualizar = this.listaDatosPorcentajesBeneficiarios.filter(x => x.id === this.formPorcentajesBeneficiarios.get('id').value)[0];
        parametroActualizar.porcentaje = this.formPorcentajesBeneficiarios.get('porcentaje').value;
        parametroActualizar.descripcion = this.formPorcentajesBeneficiarios.get('descripcion').value;
        parametroActualizar.orden = this.formPorcentajesBeneficiarios.get('orden').value;
      } else {
        this.listaDatosPorcentajesBeneficiarios.push(this.formPorcentajesBeneficiarios.value);
      }
      
      this.recargarListaPorcentajesBeneficiarios();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.formPorcentajesBeneficiarios);
    }
  }
  GuardarParametros() {
    if (this.formParametros.valid) {
      this.editarRegistroParametros = false;
      if (this.listaDatosParametros.filter(x => x.parametro === this.formParametros.get('parametro').value).length > 0) {
        let parametroActualizar = this.listaDatosParametros.filter(x => x.parametro === this.formParametros.get('parametro').value)[0];
        parametroActualizar.valorParametro = this.formParametros.get('valorParametro').value;
      }
      
      this.recargarListaParametros();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.formParametros);
    }
  }
  CancelarEditarCanal() {
    this.editarRegistroCanal = false;
  }
  CancelarEditarNotificacion() {
    this.editarRegistroNotificacion = false;
  }
  CancelarEditarPorcentajeBeneficiarios() {
    this.editarRegistroPorcentajeBeneficiarios = false;
  }
  CancelarEditarParametros() {
    this.editarRegistroParametros = false;
  }
  EliminarRegistroCanal() {
    if (this.detalleSeleccionado > 0) {
      this.listaDatosCanalesEliminar.push(this.listaDatosCanales.filter(x => x.id === this.detalleSeleccionado)[0]);
    }
    let listaNueva: Maestro_AliadosCanales[] = [];
    for (let index = 0; index < this.listaDatosCanales.length; index++) {
      if (this.listaDatosCanales[index].id !== this.detalleSeleccionado) {
        listaNueva.push(this.listaDatosCanales[index]);
      }
    }
    this.listaDatosCanales = listaNueva;
    this.recargarListaCanales();
  }
  EliminarRegistroNotificacion() {
    if (this.detalleSeleccionadoNotificacion > 0) {
      this.listaDatosNotificacionesEliminar.push(this.listaDatosNotificaciones.filter(x => x.id === this.detalleSeleccionadoNotificacion)[0]);
    }
    let listaNueva: Maestro_Notificaciones[] = [];
    for (let index = 0; index < this.listaDatosNotificaciones.length; index++) {
      if (this.listaDatosNotificaciones[index].id !== this.detalleSeleccionadoNotificacion) {
        listaNueva.push(this.listaDatosNotificaciones[index]);
      }
    }
    this.listaDatosNotificaciones = listaNueva;
    this.recargarListaNotificaciones();
  }
  EliminarRegistroPorcentajesBeneficiarios() {
    if (this.detalleSeleccionadoPorcentajeBeneficiarios > 0) {
      this.listaDatosPorcentajesBeneficiariosEliminar.push(this.listaDatosPorcentajesBeneficiarios.filter(x => x.id === this.detalleSeleccionadoPorcentajeBeneficiarios)[0]);
    }
    let listaNueva: Maestro_AliadosPorcentajeBeneficiarios[] = [];
    for (let index = 0; index < this.listaDatosPorcentajesBeneficiarios.length; index++) {
      if (this.listaDatosPorcentajesBeneficiarios[index].id !== this.detalleSeleccionadoPorcentajeBeneficiarios) {
        listaNueva.push(this.listaDatosPorcentajesBeneficiarios[index]);
      }
    }
    this.listaDatosPorcentajesBeneficiarios = listaNueva;
    this.recargarListaPorcentajesBeneficiarios();
  }
  ConsultarSectores() {
    this.mostrarCargando = true;
    let parametroConsulta = this.fb.group({
      filtro: ['']
    });
    this.sectorService.Consultar(parametroConsulta.value)
            .subscribe((resp: MaestroSectores[]) =>{
              this.listaSector = resp;
              this.ConsultarProvincias();
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  ConsultarProvincias() {
    this.mostrarCargando = true;
    let parametroConsulta = this.fb.group({
      filtro: ['']
    });
    this.provinciasService.Consultar(parametroConsulta.value)
            .subscribe((resp: Maestro_Provincias[]) =>{
              this.listaProvincias = resp;
              this.ConsultarCiudades();
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  ConsultarCiudades() {
    let parametroConsulta = this.fb.group({
      filtro: ['']
    });
    this.ciudadesServices.Consultar(parametroConsulta.value)
            .subscribe((resp: Maestro_Ciudades[]) =>{
              this.listaCiudades = resp;
              this.mostrarCargando = false;

              if (this.utilitariosService.VerificarContieneDatosTexto(this.form.get('provincia').value)) {
                this.CiudadesProvincia(this.form.get('provincia').value);
              }
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  CiudadesProvincia(provincia: string) {
    this.listaCiudadesEdicion = this.listaCiudades.filter(x => x.provincia === provincia);
  }
  CiudadesProvinciaCanales(provincia: string) {
    this.listaCiudadesEdicionCanal = this.listaCiudades.filter(x => x.provincia === provincia);
  }
  CambioSector() {
    this.form.get('sector')?.setValue('');
    if (this.utilitariosService.VerificarContieneDatosNumerico(this.form.get('sector')?.value)) {
      if (this.listaSector.filter(x => x.id === this.form.get('idSector')?.value).length > 0) {
        this.form.get('sector')?.setValue(this.listaSector.filter(x => x.id === this.form.get('idSector')?.value)[0].sector);
      }
    }
  }
  EditarContenidoHTML() {
    this._modificarplantillahtml.MostrarEdicionHtml(this.formNotificaciones.get('emailMensaje').value);
  }
  ConfirmoPlantillaHtml(textoHtml: string) {
    if (this.utilitariosService.VerificarContieneDatosTexto(textoHtml)) {
      this.formNotificaciones.get('emailMensaje').setValue(textoHtml);
      this.formNotificaciones.get('emailMensajeMostrar').setValue('Mensaje html...');
    }
  }
  MostrarFormatoProspecto(): boolean {
    if (this.form.get('cargarProspectos')?.value) {
      if (this.utilitariosService.VerificarContieneDatosTexto(this.form.get('filtroFormatoProspecto').value)) {
        let filtroFormato: string = this.form.get('filtroFormatoProspecto').value;
        if (filtroFormato.toLowerCase() !== 'excel') {
          return true;
        }
      }
    }
    return false;
  }
  Cargar_FormatoDefecto() {
    if (this.MostrarFormatoProspecto()) {
      this.form.get('nombreFormatoProspecto').setValue('CargaProspectos.fmt');
    } else {
      this.form.get('nombreFormatoProspecto').setValue('');
    }
  }
  MostrarMigracionClientesAliados(): boolean {
    return this.form.get('migracionClientesAliados')?.value;
  }
  EsEdicionRegistro(): boolean {
    return this.form.get('id').value > 0;
  }
}
